<template>
  <div class="consultation">
    <div class="consultation-content">
      <div class="consultation-top">
        <h4>Запитване за поддръжка</h4>
        <span>Изпратете запитване ако имате въпроси за поддържката, която предлагаме или имате нужда от повече информация</span>
      </div>
      <div class="consultation-content-form">
        <div class="consultation-content-form-input consultation-content-form-textarea">
          <label for="contactsMessage" v-if="isMessageValid && isMessageLengthValid">Съобщение</label>
          <label for="contactsMessage" v-else-if="!isMessageLengthValid && isMessageValid" :class="{ 'not-valid' : !isMessageLengthValid }">Допустимата дължина е 1600</label>
          <label for="contactsMessage" v-else :class="{ 'not-valid' : !isMessageValid }">Съобщението е задължително</label>

          <textarea
            id="contactsMessage"
            cols="30"
            rows="10"
            :class="{ 'not-valid-border' : !isMessageValid }"
            v-model="request.message"
          ></textarea>
        </div>
        <div class="consultation-content-form-input">
          <label for="contactsName" v-if="isNameValid">Вашето име</label>
          <label for="contactsName" v-else :class="{ 'not-valid' : !isNameValid }">Вашето име е задължително</label>
          <input
            type="text"
            id="contactsName"
            :class="{ 'not-valid-border' : !isNameValid }"
            v-model="request.name"
          />
        </div>
        <div class="consultation-content-form-input">
          <label for="contactsEmail" v-if="isEmailValid">e-mail</label>
          <label for="contactsEmail" v-else :class="{ 'not-valid' : !isEmailValid }">e-mail-а е задължителен</label>
          <input
            type="text"
            id="contactsEmail"
            :class="{ 'not-valid-border' : !isEmailValid }"
            v-model="request.email"
          />
        </div>
        <div class="consultation-content-form-input">
          <label for="contactsPhone" v-if="isPhoneValid">Телефон</label>
          <label for="contactsPhone" v-else :class="{ 'not-valid' : !isPhoneValid }">Телефона е задължителен</label>
          <input
            type="text"
            id="contactsPhone"
            :class="{ 'not-valid-border' : !isPhoneValid }"
            v-model="request.phone"
          />
        </div>
        <div class="btn-wrapper">
          <!-- <div class="captcha-wrapper" v-if="captcha">
            <p class="captcha--p" v-if="captcha.numOne && captcha.numTwo">
              {{ captcha.numOne }} + {{ captcha.numTwo }} =
            </p>
            <input
              class="captchaSum"
              :class="{ 'not-valid-border': !isCaptchaValid }"
              type="number"
              :min="0"
              oninput="validity.valid || (value='')"
              :step="0.01"
              v-model="request.captchaSum"
            />
          </div> -->
          <a
            class="consultation-content-form-submit"
            @click="sendInquiry(' за поддръжка', false)"
          >
            <template v-if="isSent">Готово</template>
            <template v-else-if="isLoading && !isSent">Един момент</template>
            <template v-else>Изпрати</template>
          </a>
        </div>
      </div>
      <!-- <div class="consultation-success" v-if="isSent">
        <p>Запитването е изпратено успешно!</p>
        <p>Ще се свържем с вас до 48 часа.</p>
      </div>-->
      <p class="agreement">
        С изпращането на това запитване вие се съгласявате с
        <router-link
          class="link"
          to="/gdpr"
          target="_blank"
        >Нашата политика за поверителност на потребителските данни</router-link>.
      </p>
    </div>
  </div>
</template>

<script>
import sendInquiry from "./mixins/sendInquiry.js";
// import captcha from './mixins/captcha.js';
export default {
  mixins: [sendInquiry],
    data() {
    return {
      // captcha: "",
    };
  },
  //   watch: {
  //   isLoading() {
  //     if (this.isLoading) {
  //       this.captcha = this.getCaptcha();
  //     }
  //   },
  // },
  // mounted() {
  //   this.captcha = this.getCaptcha();
  // },
};
</script>

<style scoped>
.consultation {
  display: flex;
  padding: 110px 50px 50px 50px;
}
/* BOTH LEFT AND RIGHT SIDE */
.consultation-top {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 2;
}
.consultation-top > h4 {
  color: #fff;
}
.consultation-top > span {
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.consultation-left .consultation-top > h4,
.consultation-left .consultation-top > span {
  color: #000;
}
/* RIGHT */
.consultation-content {
  align-items: center;
  border-radius: 15px;
  background-color: #313131;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 50px 0;
  position: relative;
  width: 100%;
}
.consultation-content::before {
  background-image: url("/static/img/services.png");
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: auto 100%;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  content: "";
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.consultation-success p {
  color: #c4c4c4;
  font-size: 24px;
  text-align: center;
}
.consultation-content-form {
  position: relative;
  z-index: 2;
}
.consultation-content-form-input {
  height: 60px;
  margin: 26px 0;
  position: relative;
  width: 410px;
}
.consultation-content-form-textarea {
  height: 110px;
}
.consultation-content-form-input > input,
.consultation-content-form-input > textarea {
  background-color: #313131;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  outline: none;
  padding: 0 25px;
  width: 100%;
  height: 60px;
}
.consultation-content-form-input > textarea {
  height: 110px;
  padding: 25px;
  resize: none;
}
.consultation-content-form-input > label {
  background-color: #313131;
  color: #fff;
  font-size: 16px;
  left: 15px;
  padding: 0 10px;
  position: absolute;
  top: -9px;
}
.btn-wrapper {
  display: flex;
  gap: 15px;
  padding-top: 10px;
  justify-content: center;
  text-align: center;
  width: 100%;
}
.captcha-wrapper {
  align-items: center;
  display: flex;
}
  .captcha--p {
     color: #fff;
    font-size: 14px;
    white-space: nowrap;
  }
  .captchaSum {
  background-color: #313131;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  outline: none;
  margin-left: 5px;
  max-width: 50px;
  padding: 5px;
  }
.consultation-content-form-submit {
  align-items: center;
  background-color: #ffffff;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  width: 178px;
}
.consultation-content-form-submit:hover {
  background-color: #ebebeb;
}
.agreement {
  color: rgba(138, 138, 138, 0.8);
  font-size: 12px;
  text-align: center;
  margin: 15px 0;
  position: relative;
  width: 410px;
  z-index: 2;
}
.link {
  color: rgba(138, 138, 138, 0.8);
  text-decoration: underline;
}
@media screen and (max-width: 2560px) {
  .consultation {
    display: flex;
    padding: 30px 50px 50px 50px;
  }
}
@media screen and (max-width: 1920px) {
  .consultation {
    display: flex;
    padding: 0px 50px 50px 50px;
  }
}
@media screen and (max-width: 1600px) {
  .consultation {
    display: flex;
    padding: 30px 50px 50px 50px;
  }
  .consultation-content-form-input {
    height: 50px;
    margin: 20px 0;
    width: 350px;
  }
  .consultation-content-form-input > input {
    height: 50px;
  }
  .consultation-content-form-textarea,
  .consultation-content-form-input > textarea {
    height: 100px;
  }
  .btn-wrapper {
    align-items: center;
    flex-direction: column;
    padding-top: 0;
  }
  .consultation-success p {
    font-size: 20px;
  }
}
@media screen and (max-width: 1440px) {
  .consultation {
    margin-top: -40px;
  }
  .consultation-content {
    padding-top: 100px;
  }
  .consultation-content-form-submit {
    font-size: 14px;
  }
  .consultation-content-form-input > label {
    font-size: 14px;
    top: -8px;
  }
}
@media screen and (max-width: 1366px) {
  .consultation {
    margin-top: -10px;
  }
  .consultation-top > span {
    font-size: 12px;
  }
  .consultation-content-form-input {
    height: 40px;
    margin: 15px 0;
    width: 300px;
  }
  .consultation-content-form-input > label {
    font-size: 12px;
  }
  .consultation-content-form-input > input {
    font-size: 14px;
    height: 40px;
  }
  .consultation-content-form-textarea,
  .consultation-content-form-input > textarea {
    font-size: 14px;
    height: 80px;
  }
  .consultation-content-form-submit {
    height: 40px;
    width: 150px;
  }
  .agreement {
    font-size: 10px;
  }
}
@media screen and (max-width: 1280px) {
  .consultation {
    flex-direction: column;
    height: initial;
  }
  .consultation-content {
    min-height: initial;
    width: 100%;
  }
  .consultation-content::before {
    opacity: 0.02;
  }
  .consultation-content {
    padding: 50px 20px 63px;
  }
}
@media screen and (max-width: 600px) {
  .consultation {
    margin: -50px 0 10px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .consultation-content {
    padding-bottom: 50px;
  }
  .consultation-content-form,
  .agreement {
    width: 250px;
  }
  .consultation-content-form-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConsultationServ.vue